export const useFormNonComplianceInterpolationsFetcher = skip => {
  if (skip) return []

  return [
    {
      name: 'Nome do destino',
      id: '{{forms_non_compliance_event.non_compliance.place.name}}',
      type: 'string',
      group: 'Destino'
    },
    {
      name: 'Nome completo do destino',
      id: '{{forms_non_compliance_event.non_compliance.place.resume}} - {{forms_non_compliance_event.non_compliance.place.name}}',
      type: 'string',
      group: 'Destino'
    },
    {
      name: 'Pergunta',
      id: '{{forms_non_compliance_event.non_compliance.question.name}}',
      type: 'string',
      group: 'Pergunta'
    }
  ]
}

export const useFormNonComplianceRawInterpolationsFetcher = skip => {
  if (skip) return []

  return [
    {
      name: 'Local da não conformidade atualizada',
      id: '::{{forms_non_compliance_event.non_compliance.place_id}}',
      type: 'raw_place'
    },
    {
      name: 'Questionário do formulário respondido',
      id: '::{{forms_non_compliance_event.reply.question.checklist_id}}',
      type: 'raw_checklist'
    }
  ]
}
